import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createUserActions } from './user.actions'
import { userInitialState } from './user.slice'
import type { UserStore } from './user.type'

export const useUserStore = create<UserStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...userInitialState,
        ...createUserActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.User,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
